/*global __CLIENT__*/
import React, { Component } from 'react';
import '../../styles/ToastItem.css';

export default class ToastItem extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="notification-list bg-danger">{this.props.toast}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ToastContainer/ToastItem.js